import AppleAppStore from '@rhg/../public/_n/images/appleappstore.svg';
import GooglePlay from '@rhg/../public/_n/images/googleplay.svg';
import useAppConfig from '@rhg/hooks/use-app-config';
import commonMessages from '@rhg/lang/messages/common';
import {
    ButtonBase,
    ButtonBaseProps,
    SxProps,
    Theme,
} from '@rhg/libs/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { ChLink } from '../ch-link';

export interface DownloadMobileLinkProps extends ButtonBaseProps {
    href: string;
    image: React.ReactElement;
    label?: string;
    onClick?: React.MouseEventHandler<any>;
    sx?: SxProps<Theme>;
}

// TODO May need i18n on these which will require special logic to change the SVGs
export const DownloadMobileLink = ({
    href,
    image,
    label,
    onClick,
    sx,
    trackButton,
}: DownloadMobileLinkProps) => (
    <ButtonBase
        component={ChLink}
        href={href}
        onClick={onClick}
        sx={sx}
        target="_blank"
        trackButton={trackButton}
        aria-label={label}
    >
        {image}
    </ButtonBase>
);

export type AppLinkType = 'calm' | 'calmHealth';

export interface AppLinkProps {
    link?: AppLinkType;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    sx?: SxProps<Theme>;
    href?: string;
}

export const AppleAppStoreLink = ({
    link,
    onClick,
    sx,
    href,
}: AppLinkProps) => {
    const appConfig = useAppConfig();
    const { formatMessage } = useIntl();
    return (
        <DownloadMobileLink
            href={
                href
                    ? href
                    : link === 'calm'
                    ? appConfig.NEXT_PUBLIC_LINK_CALM_APPLE_APP_STORE
                    : appConfig.NEXT_PUBLIC_LINK_APPLE_APP_STORE
            }
            image={<AppleAppStore />}
            label={
                link === 'calm'
                    ? formatMessage(commonMessages['common.calmAppleAppStore'])
                    : formatMessage(commonMessages['common.appleAppStore'])
            }
            onClick={onClick}
            sx={sx}
            trackButton={
                link === 'calm' ? 'CalmAppStoreDownload' : 'AppStoreDownload'
            }
        />
    );
};

export const GooglePlayLink = ({ link, onClick, sx, href }: AppLinkProps) => {
    const appConfig = useAppConfig();
    const { formatMessage } = useIntl();
    return (
        <DownloadMobileLink
            href={
                href
                    ? href
                    : link === 'calm'
                    ? appConfig.NEXT_PUBLIC_LINK_CALM_GOOGLE_PLAY
                    : appConfig.NEXT_PUBLIC_LINK_GOOGLE_PLAY
            }
            image={<GooglePlay />}
            label={formatMessage(
                commonMessages[
                    link === 'calm'
                        ? 'common.calmGooglePlay'
                        : 'common.googlePlay'
                ]
            )}
            onClick={onClick}
            sx={sx}
            trackButton={
                link === 'calm'
                    ? 'CalmGooglePlayDownload'
                    : 'GooglePlayDownload'
            }
        />
    );
};
